<app-welcome-section></app-welcome-section>
<app-about-section *ngIf="globals.isDesktop"></app-about-section>
<app-projects-section></app-projects-section>
<app-events-section [inHomePage]="true"></app-events-section>
<app-home-communities></app-home-communities>
<app-home-join *ngIf="!dataService.isUserLoggedIn"></app-home-join>

<app-home-partners></app-home-partners>
<app-home-press></app-home-press>
